import './disclaimer.less'
import Analytics from '../../components/SiteNav/analytics.js'

class AmeripriseFooterDisclaimer extends HTMLElement {
  private shadow!: ShadowRoot
  private template: HTMLTemplateElement | null = null

  connectedCallback() {
    this.shadow = this.attachShadow({ mode: 'open' })

    // TODO move/remove this functionality
    // this sets the Find An Advisor button href and analytics

    this.template = this.querySelector(
      '#disclaimer-template'
    ) as HTMLTemplateElement | null

    if (this.template?.content) {
      this.shadow.appendChild(this.template.content)
    }

    /* Footer disclosures and Social Network links Analytics */
    const footerDisclaimerContent = this.shadow.querySelector(
      '.amp-footerSocialAndDisclaimer'
    )
    const disclaimerLinks = footerDisclaimerContent?.getElementsByTagName('a')
    if (disclaimerLinks && disclaimerLinks.length > 0) {
      Array.from(disclaimerLinks).forEach(link => {
        link.addEventListener('click', event => {
          const disclaimerMessage = (event.currentTarget as HTMLElement)
            ?.innerText
          const type = 'footer'

          try {
            const disclaimerAnalytics = new Analytics()
            disclaimerAnalytics.ping(disclaimerMessage, type)
          } catch (e) {
            console.error(e)
          }
        })
      })
    }
  }
}

if (!window.customElements.get('ameriprise-footer-disclaimer')) {
  window.customElements.define(
    'ameriprise-footer-disclaimer',
    AmeripriseFooterDisclaimer
  )
}
